import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
export default ItemsV3Serializer.extend({
  attrs: {
    timePeriods: {
      serialize: 'ids',
      deserialize: 'ids'
    },
    dateRangePeriod: {
      serialize: 'ids',
      deserialize: 'ids'
    }
  }
});